import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  period: {
    '@$': 'focusedRange',
  },
  selection: {
    '{}': {
      name: 'Metrics',
      type: 'report-card',
      content: {
        if: [
          [
            {
              and: [
                {
                  not: {
                    '=': [
                      {
                        '@$': 'spaceRecordId',
                      },
                      null,
                    ],
                  },
                },
                {
                  not: {
                    '=': [
                      {
                        '@$': 'spaceEntityId',
                      },
                      null,
                    ],
                  },
                },
              ],
            },
            {
              '[]': [
                {
                  '{}': {
                    name: 'Space Metrics',
                    values: {
                      '[]': [
                        {
                          '{}': {
                            name: 'ASF',
                            value: {
                              '{}': {
                                tooltip: 'Total Assignable Square Footage',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'rooms',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      scalar: 0.001,
                                      suffix: 'K',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'Total Area',
                            value: {
                              '{}': {
                                tooltip: 'Total Area',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'rooms',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'sqft',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'Utilization',
                            value: {
                              '{}': {
                                tooltip: 'ASF / Total Area',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '/': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'sqft',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      ',': true,
                                      '.': {
                                        max: 2,
                                        min: 2,
                                      },
                                      scalar: 100,
                                      suffix: '%',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                      ],
                    },
                  },
                },
              ],
            },
          ],
          [
            {
              and: [
                {
                  not: {
                    '=': [
                      {
                        '@$': 'orgRecordId',
                      },
                      null,
                    ],
                  },
                },
                {
                  not: {
                    '=': [
                      {
                        '@$': 'orgEntityId',
                      },
                      null,
                    ],
                  },
                },
              ],
            },
            {
              '[]': [
                {
                  '{}': {
                    name: 'Total',
                    values: {
                      '[]': [
                        {
                          '{}': {
                            name: 'TDC',
                            value: {
                              '{}': {
                                tooltip:
                                  'Total Direct Cost - All direct expenses charged to a research project.',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'org',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'tdcAmount',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      scalar: 0.000001,
                                      suffix: 'M',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'MTDC',
                            value: {
                              '{}': {
                                tooltip:
                                  'Modified Total Direct Cost - TDC excluding equipment, capital costs, patient care, tuition, and large subawards.',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'org',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'mtdcAmount',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      scalar: 0.000001,
                                      suffix: 'M',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'MTDC Average',
                            value: {
                              '{}': {
                                tooltip: '3-Year average of MTDC',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '/': [
                                        {
                                          '+': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2022_org',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'mtdcAmount',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2023_org',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'mtdcAmount',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2024_org',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'mtdcAmount',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                        3,
                                      ],
                                    },
                                    {
                                      scalar: 0.000001,
                                      suffix: 'M',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'ASF',
                            value: {
                              '{}': {
                                tooltip: 'Total Assignable Square Footage',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'org',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'totalAsf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      scalar: 0.001,
                                      suffix: 'K',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  '{}': {
                    name: 'Density',
                    values: {
                      '[]': [
                        {
                          '{}': {
                            name: 'TDC Density',
                            value: {
                              '{}': {
                                tooltip: 'Total TDC / Total ASF',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'org',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'tdcDensity',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'MTDC Density',
                            value: {
                              '{}': {
                                tooltip: 'Total MTDC / Total ASF',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'org',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'mtdcDensity',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'MTDC Average Density',
                            value: {
                              '{}': {
                                aside: 'goal of 250 / ASF',
                                quality: {
                                  if: [
                                    [
                                      {
                                        '>=': [
                                          {
                                            '/': [
                                              {
                                                '+': [
                                                  {
                                                    '+': {
                                                      '->': [
                                                        {
                                                          '@': '2022_org',
                                                        },
                                                        {
                                                          '@>': [
                                                            {
                                                              '@$': '$value',
                                                            },
                                                            'mtdcDensity',
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  },
                                                  {
                                                    '+': {
                                                      '->': [
                                                        {
                                                          '@': '2023_org',
                                                        },
                                                        {
                                                          '@>': [
                                                            {
                                                              '@$': '$value',
                                                            },
                                                            'mtdcDensity',
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  },
                                                  {
                                                    '+': {
                                                      '->': [
                                                        {
                                                          '@': '2024_org',
                                                        },
                                                        {
                                                          '@>': [
                                                            {
                                                              '@$': '$value',
                                                            },
                                                            'mtdcDensity',
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  },
                                                ],
                                              },
                                              3,
                                            ],
                                          },
                                          250,
                                        ],
                                      },
                                      'good',
                                    ],
                                    'bad',
                                  ],
                                },
                                tooltip: '3-Year MTDC Average / Total ASF',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '/': [
                                        {
                                          '+': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2022_org',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'mtdcDensity',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2023_org',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'mtdcDensity',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2024_org',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'mtdcDensity',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                        3,
                                      ],
                                    },
                                    {
                                      ',': true,
                                      '.': {
                                        max: 2,
                                        min: 2,
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  '{}': {
                    name: 'Other',
                    values: {
                      '[]': [
                        {
                          '{}': {
                            name: 'Utilization',
                            value: {
                              '{}': {
                                tooltip:
                                  'Percentage of ASF actively used for research.',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'org',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'utilization',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      ',': true,
                                      '.': {
                                        max: 2,
                                        min: 2,
                                      },
                                      scalar: 100,
                                      suffix: '%',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                      ],
                    },
                  },
                },
              ],
            },
          ],
          [
            {
              not: {
                '=': [
                  {
                    '@$': 'piRecordId',
                  },
                  null,
                ],
              },
            },
            {
              '[]': [
                {
                  '{}': {
                    name: 'Total',
                    values: {
                      '[]': [
                        {
                          '{}': {
                            name: 'TDC',
                            value: {
                              '{}': {
                                tooltip:
                                  'Total Direct Cost - All direct expenses charged to a research project.',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'pi',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'tdcAmount',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      scalar: 0.000001,
                                      suffix: 'M',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'MTDC',
                            value: {
                              '{}': {
                                tooltip:
                                  'Modified Total Direct Cost - TDC excluding equipment, capital costs, patient care, tuition, and large subawards.',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'pi',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'mtdcAmount',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      scalar: 0.000001,
                                      suffix: 'M',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'MTDC Average',
                            value: {
                              '{}': {
                                tooltip: '3-Year average of MTDC',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '/': [
                                        {
                                          '+': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2022_pi',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'mtdcAmount',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2023_pi',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'mtdcAmount',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2024_pi',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'mtdcAmount',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                        3,
                                      ],
                                    },
                                    {
                                      scalar: 0.000001,
                                      suffix: 'M',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'ASF',
                            value: {
                              '{}': {
                                tooltip: 'Total Assignable Square Footage',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'pi',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'totalAsf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      scalar: 0.001,
                                      suffix: 'K',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  '{}': {
                    name: 'Density',
                    values: {
                      '[]': [
                        {
                          '{}': {
                            name: 'TDC Density',
                            value: {
                              '{}': {
                                tooltip: 'Total TDC / Total ASF',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'pi',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'tdcDensity',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'MTDC Density',
                            value: {
                              '{}': {
                                tooltip: 'Total MTDC / Total ASF',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'pi',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'mtdcDensity',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            name: 'MTDC Average Density',
                            value: {
                              '{}': {
                                aside: 'goal of 250 / ASF',
                                quality: {
                                  if: [
                                    [
                                      {
                                        '>=': [
                                          {
                                            '/': [
                                              {
                                                '+': [
                                                  {
                                                    '+': {
                                                      '->': [
                                                        {
                                                          '@': '2022_pi',
                                                        },
                                                        {
                                                          '@>': [
                                                            {
                                                              '@$': '$value',
                                                            },
                                                            'mtdcDensity',
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  },
                                                  {
                                                    '+': {
                                                      '->': [
                                                        {
                                                          '@': '2023_pi',
                                                        },
                                                        {
                                                          '@>': [
                                                            {
                                                              '@$': '$value',
                                                            },
                                                            'mtdcDensity',
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  },
                                                  {
                                                    '+': {
                                                      '->': [
                                                        {
                                                          '@': '2024_pi',
                                                        },
                                                        {
                                                          '@>': [
                                                            {
                                                              '@$': '$value',
                                                            },
                                                            'mtdcDensity',
                                                          ],
                                                        },
                                                      ],
                                                    },
                                                  },
                                                ],
                                              },
                                              3,
                                            ],
                                          },
                                          250,
                                        ],
                                      },
                                      'good',
                                    ],
                                    'bad',
                                  ],
                                },
                                tooltip: '3-Year MTDC Average / Total ASF',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '/': [
                                        {
                                          '+': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2022_pi',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'mtdcDensity',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2023_pi',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'mtdcDensity',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': '2024_pi',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'mtdcDensity',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                          ],
                                        },
                                        3,
                                      ],
                                    },
                                    {
                                      ',': true,
                                      '.': {
                                        max: 2,
                                        min: 2,
                                      },
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                      ],
                    },
                  },
                },
                {
                  '{}': {
                    name: 'Other',
                    values: {
                      '[]': [
                        {
                          '{}': {
                            name: 'Utilization',
                            value: {
                              '{}': {
                                tooltip:
                                  'Percentage of ASF actively used for research.',
                                emphasis: {
                                  'fmt.num': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'pi',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'utilization',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    {
                                      ',': true,
                                      '.': {
                                        max: 2,
                                        min: 2,
                                      },
                                      scalar: 100,
                                      suffix: '%',
                                    },
                                  ],
                                },
                              },
                            },
                          },
                        },
                      ],
                    },
                  },
                },
              ],
            },
          ],
          {
            '[]': [
              {
                '{}': {
                  name: 'Total',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'TDC',
                          value: {
                            '{}': {
                              tooltip:
                                'Total Direct Cost - All direct expenses charged to a research project.',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projectsGlExpenses',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'tdcAmount',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    scalar: 0.000001,
                                    suffix: 'M',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'MTDC',
                          value: {
                            '{}': {
                              tooltip:
                                'Modified Total Direct Cost - TDC excluding equipment, capital costs, patient care, tuition, and large subawards.',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projectsGlExpenses',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'mtdcAmount',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    scalar: 0.000001,
                                    suffix: 'M',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'MTDC Average',
                          value: {
                            '{}': {
                              tooltip: '3-Year average of MTDC',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '/': [
                                      {
                                        '+': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': '2022_projectsGlExpenses',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'mtdcAmount',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': '2023_projectsGlExpenses',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'mtdcAmount',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': '2024_projectsGlExpenses',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'mtdcAmount',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                      3,
                                    ],
                                  },
                                  {
                                    scalar: 0.000001,
                                    suffix: 'M',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'ASF',
                          value: {
                            '{}': {
                              tooltip: 'Total Assignable Square Footage',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    scalar: 0.001,
                                    suffix: 'K',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              {
                '{}': {
                  name: 'Density',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'TDC Density',
                          value: {
                            '{}': {
                              tooltip: 'Total TDC / Total ASF',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '/': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'projectsGlExpenses',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'tdcAmount',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'rooms',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'asf',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    ',': true,
                                    '.': {
                                      max: 2,
                                      min: 2,
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'MTDC Density',
                          value: {
                            '{}': {
                              tooltip: 'Total MTDC / Total ASF',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '/': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'projectsGlExpenses',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'mtdcAmount',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'rooms',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'asf',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    ',': true,
                                    '.': {
                                      max: 2,
                                      min: 2,
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'MTDC Average Density',
                          value: {
                            '{}': {
                              aside: 'goal of 250 / ASF',
                              quality: {
                                if: [
                                  [
                                    {
                                      '>=': [
                                        {
                                          '/': [
                                            {
                                              '+': [
                                                {
                                                  '/': [
                                                    {
                                                      '+': {
                                                        '->': [
                                                          {
                                                            '@': '2022_projectsGlExpenses',
                                                          },
                                                          {
                                                            '@>': [
                                                              {
                                                                '@$': '$value',
                                                              },
                                                              'mtdcAmount',
                                                            ],
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      '+': {
                                                        '->': [
                                                          {
                                                            '@': 'rooms',
                                                          },
                                                          {
                                                            '@>': [
                                                              {
                                                                '@$': '$value',
                                                              },
                                                              'asf',
                                                            ],
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                                {
                                                  '/': [
                                                    {
                                                      '+': {
                                                        '->': [
                                                          {
                                                            '@': '2023_projectsGlExpenses',
                                                          },
                                                          {
                                                            '@>': [
                                                              {
                                                                '@$': '$value',
                                                              },
                                                              'mtdcAmount',
                                                            ],
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      '+': {
                                                        '->': [
                                                          {
                                                            '@': 'rooms',
                                                          },
                                                          {
                                                            '@>': [
                                                              {
                                                                '@$': '$value',
                                                              },
                                                              'asf',
                                                            ],
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                                {
                                                  '/': [
                                                    {
                                                      '+': {
                                                        '->': [
                                                          {
                                                            '@': '2024_projectsGlExpenses',
                                                          },
                                                          {
                                                            '@>': [
                                                              {
                                                                '@$': '$value',
                                                              },
                                                              'mtdcAmount',
                                                            ],
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      '+': {
                                                        '->': [
                                                          {
                                                            '@': 'rooms',
                                                          },
                                                          {
                                                            '@>': [
                                                              {
                                                                '@$': '$value',
                                                              },
                                                              'asf',
                                                            ],
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              ],
                                            },
                                            3,
                                          ],
                                        },
                                        250,
                                      ],
                                    },
                                    'good',
                                  ],
                                  'bad',
                                ],
                              },
                              tooltip: '3-Year MTDC Average / Total ASF',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '/': [
                                      {
                                        '+': [
                                          {
                                            '/': [
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': '2022_projectsGlExpenses',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'mtdcAmount',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': 'rooms',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'asf',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                          {
                                            '/': [
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': '2023_projectsGlExpenses',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'mtdcAmount',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': 'rooms',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'asf',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                          {
                                            '/': [
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': '2024_projectsGlExpenses',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'mtdcAmount',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': 'rooms',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'asf',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        ],
                                      },
                                      3,
                                    ],
                                  },
                                  {
                                    ',': true,
                                    '.': {
                                      max: 2,
                                      min: 2,
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              {
                '{}': {
                  name: 'Other',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Utilization',
                          value: {
                            '{}': {
                              tooltip:
                                'Percentage of ASF actively used for research.',
                              emphasis: {
                                'fmt.num': [
                                  {
                                    '/': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'rooms',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'asf',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'rooms',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'sqft',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    ',': true,
                                    '.': {
                                      max: 2,
                                      min: 2,
                                    },
                                    scalar: 100,
                                    suffix: '%',
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
        ],
      },
    },
  },
  variables: {
    focusedRange: {
      $range: {
        end: {
          $date: '12/31/2024',
        },
        start: {
          $date: '1/1/2024',
        },
      },
    },
    researchType: ['BASIC RESEARCH'],
    shouldAnalyze: true,
  },
  subqueries: {
    pi: {
      filter: {
        and: [
          {
            '@$': 'piRecordId',
          },
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '{}': {
          name: {
            '@.': '!name',
          },
          totalAsf: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'asf',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          tdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          totalSqft: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'sqft',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          mtdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          tdcDensity: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'tdcAmount',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
          mtdcDensity: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'mtdcAmount',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
          utilization: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalSqft',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'totalAsf',
                  },
                  {
                    '@>': 'totalSqft',
                  },
                ],
              },
            ],
          },
        },
      },
      subqueries: {
        rooms: {
          ref: {
            attr: 'attr:ent#!person_space#!entry:!space',
          },
          using: 'piSpaceAssignments',
          filter: {
            and: [
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'spaceType',
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': [
                          '!space_use',
                          {
                            ref: {
                              entity: '!group',
                            },
                          },
                        ],
                      },
                      {
                        '@>': [
                          {
                            '@$': 'spaceType',
                          },
                          'ent:!space_use:!group',
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                if: [
                  [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      '=': [
                        {
                          '@$': 'shouldAnalyze',
                        },
                        {
                          in: [
                            true,
                            {
                              '@': 'shouldAnalyze',
                            },
                          ],
                        },
                      ],
                    },
                  ],
                  true,
                ],
              },
            ],
          },
          target: 'ent:!space:!room',
          selection: {
            '{}': {
              asf: {
                '*': [
                  {
                    '@.': '!sqft',
                  },
                  {
                    '/': [
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '*': [
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'allowable',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              sqft: {
                '@.': '!sqft',
              },
            },
          },
          subqueries: {
            weights: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!space',
                inherit: '-',
              },
              filter: {
                '!=': [
                  {
                    '@.': '!weight',
                  },
                  0,
                ],
              },
              target: 'ent:!space_funcl:!entry',
              selection: {
                '{}': {
                  value: {
                    '@.': '!weight',
                  },
                  allowable: {
                    if: [
                      [
                        {
                          '!=': [
                            {
                              '@': 'funcIdCat',
                            },
                            null,
                          ],
                        },
                        1,
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                funcIdCat: {
                  ref: {
                    attr: 'attr:ent#!space_funcl#!entry:!func_space',
                  },
                  target: 'ent:!func_space:!func',
                  selection: {
                    '@.': [
                      '!func_idc',
                      {
                        ref: {
                          entity: '!cat',
                        },
                      },
                    ],
                  },
                },
              },
            },
            roomOrgs: {
              ref: {
                attr: 'attr:ent#!org_space#!entry:!space',
              },
              target: 'ent:!org_space:!entry',
            },
            shouldAnalyze: {
              ref: {
                attr: 'attr:ent#!org_space#!entry:!org',
              },
              using: 'roomOrgs',
              target: 'dim::!org',
              selection: {
                '@.': '!should_analyze',
              },
            },
          },
        },
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          using: 'piProjectAssignments',
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'researchType',
                      },
                      null,
                    ],
                  },
                  {
                    '=': [
                      {
                        '#': {
                          '@$': 'researchType',
                        },
                      },
                      0,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': '!research_type_wfuhs',
                      },
                      {
                        '@$': 'researchType',
                      },
                    ],
                  },
                ],
              },
              {
                if: [
                  [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      '=': [
                        {
                          '@$': 'shouldAnalyze',
                        },
                        {
                          '@': 'shouldAnalyze',
                        },
                      ],
                    },
                  ],
                  true,
                ],
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '{}': {
              tdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              mtdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
            },
          },
          subqueries: {
            shouldAnalyze: {
              ref: {
                attr: 'attr:ent#!projects#!proj:!org',
              },
              target: 'ent:!org:!dept',
              selection: {
                '@.': '!should_analyze',
              },
            },
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  tdcAmount: {
                    '@.': '!amount',
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '@': 'isInMtdc',
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                isInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!is_in_mtdc',
                  },
                },
              },
            },
          },
        },
        piSpaceAssignments: {
          ref: {
            attr: 'attr:ent#!person_space#!entry:!personnel',
          },
          target: 'ent:!person_space:!entry',
        },
        piProjectAssignments: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!pi',
          },
          target: 'ent:!proj_pis:!entry',
        },
      },
    },
    org: {
      filter: {
        and: [
          {
            '@$': 'orgEntityId',
          },
          {
            '@$': 'orgRecordId',
          },
          {
            '=': [
              {
                '@.': '!id',
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            '=': [
              {
                '@_': 'id',
              },
              {
                '@$': 'orgEntityId',
              },
            ],
          },
        ],
      },
      target: 'dim::!org',
      selection: {
        '{}': {
          totalAsf: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'asf',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          tdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          totalSqft: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'sqft',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          mtdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          tdcDensity: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'tdcAmount',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
          mtdcDensity: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'mtdcAmount',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
          utilization: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalSqft',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'totalAsf',
                  },
                  {
                    '@>': 'totalSqft',
                  },
                ],
              },
            ],
          },
        },
      },
      subqueries: {
        rooms: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          using: 'orgSpaceAssignments',
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': [
                      '!space_use',
                      {
                        ref: {
                          entity: '!group',
                        },
                      },
                    ],
                  },
                  {
                    '@>': [
                      {
                        '@$': 'spaceType',
                      },
                      'ent:!space_use:!group',
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!space:!room',
          selection: {
            '{}': {
              asf: {
                '*': [
                  {
                    '@.': '!sqft',
                  },
                  {
                    '/': [
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '*': [
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'allowable',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              sqft: {
                '@.': '!sqft',
              },
            },
          },
          subqueries: {
            weights: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!space',
                inherit: '-',
              },
              filter: {
                '!=': [
                  {
                    '@.': '!weight',
                  },
                  0,
                ],
              },
              target: 'ent:!space_funcl:!entry',
              selection: {
                '{}': {
                  value: {
                    '@.': '!weight',
                  },
                  allowable: {
                    if: [
                      [
                        {
                          '!=': [
                            {
                              '@': 'funcIdCat',
                            },
                            null,
                          ],
                        },
                        1,
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                funcIdCat: {
                  ref: {
                    attr: 'attr:ent#!space_funcl#!entry:!func_space',
                  },
                  target: 'ent:!func_space:!func',
                  selection: {
                    '@.': [
                      '!func_idc',
                      {
                        ref: {
                          entity: '!cat',
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
            inherit: '-',
          },
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'researchType',
                      },
                      null,
                    ],
                  },
                  {
                    '=': [
                      {
                        '#': {
                          '@$': 'researchType',
                        },
                      },
                      0,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': '!research_type_wfuhs',
                      },
                      {
                        '@$': 'researchType',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '{}': {
              tdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'tdcAmount',
                      ],
                    },
                  ],
                },
              },
              mtdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  tdcAmount: {
                    '@.': '!amount',
                  },
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '@': 'isInMtdc',
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                isInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!is_in_mtdc',
                  },
                },
              },
            },
          },
        },
        orgSpaceAssignments: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!org',
            inherit: '-',
          },
          target: 'ent:!org_space:!entry',
        },
      },
    },
    rooms: {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'spaceEntityId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@$': 'spaceEntityId',
                            },
                            'ent:!space:!campus',
                          ],
                        },
                        {
                          '@^': '!campus',
                        },
                      ],
                      [
                        {
                          '=': [
                            {
                              '@$': 'spaceEntityId',
                            },
                            'ent:!space:!bldg',
                          ],
                        },
                        {
                          '@^': '!bldg',
                        },
                      ],
                      [
                        {
                          '=': [
                            {
                              '@$': 'spaceEntityId',
                            },
                            'ent:!space:!floor',
                          ],
                        },
                        {
                          '@^': '!floor',
                        },
                      ],
                      {
                        '@.': '!id',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': [
                      '!space_use',
                      {
                        ref: {
                          entity: '!group',
                        },
                      },
                    ],
                  },
                  {
                    '@>': [
                      {
                        '@$': 'spaceType',
                      },
                      'ent:!space_use:!group',
                    ],
                  },
                ],
              },
            ],
          },
          {
            if: [
              [
                {
                  '@$': 'shouldAnalyze',
                },
                {
                  '=': [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      in: [
                        true,
                        {
                          '@': 'shouldAnalyze',
                        },
                      ],
                    },
                  ],
                },
              ],
              true,
            ],
          },
        ],
      },
      target: 'ent:!space:!room',
      selection: {
        '{}': {
          asf: {
            '*': [
              {
                '@.': '!sqft',
              },
              {
                '/': [
                  {
                    '+': {
                      '->': [
                        {
                          '@': 'weights',
                        },
                        {
                          '*': [
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'allowable',
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  },
                  {
                    '+': {
                      '->': [
                        {
                          '@': 'weights',
                        },
                        {
                          '@>': [
                            {
                              '@$': '$value',
                            },
                            'value',
                          ],
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
          sqft: {
            '@.': '!sqft',
          },
        },
      },
      subqueries: {
        weights: {
          ref: {
            attr: 'attr:ent#!space_funcl#!entry:!space',
            inherit: '-',
          },
          filter: {
            '!=': [
              {
                '@.': '!weight',
              },
              0,
            ],
          },
          target: 'ent:!space_funcl:!entry',
          selection: {
            '{}': {
              value: {
                '@.': '!weight',
              },
              allowable: {
                if: [
                  [
                    {
                      '!=': [
                        {
                          '@': 'funcIdCat',
                        },
                        null,
                      ],
                    },
                    1,
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            funcIdCat: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!func_space',
              },
              target: 'ent:!func_space:!func',
              selection: {
                '@.': [
                  '!func_idc',
                  {
                    ref: {
                      entity: '!cat',
                    },
                  },
                ],
              },
            },
          },
        },
        roomOrgs: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          target: 'ent:!org_space:!entry',
        },
        shouldAnalyze: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!org',
          },
          using: 'roomOrgs',
          target: 'dim::!org',
          selection: {
            '@.': '!should_analyze',
          },
        },
      },
    },
    '2022_pi': {
      filter: {
        and: [
          {
            '@$': 'piRecordId',
          },
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2022',
          },
          start: {
            $date: '1/1/2022',
          },
        },
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '{}': {
          totalAsf: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'asf',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          mtdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          mtdcDensity: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'mtdcAmount',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
        },
      },
      subqueries: {
        rooms: {
          ref: {
            attr: 'attr:ent#!person_space#!entry:!space',
          },
          using: 'piSpaceAssignments',
          filter: {
            and: [
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'spaceType',
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': [
                          '!space_use',
                          {
                            ref: {
                              entity: '!group',
                            },
                          },
                        ],
                      },
                      {
                        '@>': [
                          {
                            '@$': 'spaceType',
                          },
                          'ent:!space_use:!group',
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                if: [
                  [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      '=': [
                        {
                          '@$': 'shouldAnalyze',
                        },
                        {
                          in: [
                            true,
                            {
                              '@': 'shouldAnalyze',
                            },
                          ],
                        },
                      ],
                    },
                  ],
                  true,
                ],
              },
            ],
          },
          target: 'ent:!space:!room',
          selection: {
            '{}': {
              asf: {
                '*': [
                  {
                    '@.': '!sqft',
                  },
                  {
                    '/': [
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '*': [
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'allowable',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              sqft: {
                '@.': '!sqft',
              },
            },
          },
          subqueries: {
            weights: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!space',
                inherit: '-',
              },
              filter: {
                '!=': [
                  {
                    '@.': '!weight',
                  },
                  0,
                ],
              },
              target: 'ent:!space_funcl:!entry',
              selection: {
                '{}': {
                  value: {
                    '@.': '!weight',
                  },
                  allowable: {
                    if: [
                      [
                        {
                          '!=': [
                            {
                              '@': 'funcIdCat',
                            },
                            null,
                          ],
                        },
                        1,
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                funcIdCat: {
                  ref: {
                    attr: 'attr:ent#!space_funcl#!entry:!func_space',
                  },
                  target: 'ent:!func_space:!func',
                  selection: {
                    '@.': [
                      '!func_idc',
                      {
                        ref: {
                          entity: '!cat',
                        },
                      },
                    ],
                  },
                },
              },
            },
            roomOrgs: {
              ref: {
                attr: 'attr:ent#!org_space#!entry:!space',
              },
              target: 'ent:!org_space:!entry',
            },
            shouldAnalyze: {
              ref: {
                attr: 'attr:ent#!org_space#!entry:!org',
              },
              using: 'roomOrgs',
              target: 'ent:!org:!dept',
              selection: {
                '@.': '!should_analyze',
              },
            },
          },
        },
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          using: 'piProjectAssignments',
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'researchType',
                      },
                      null,
                    ],
                  },
                  {
                    '=': [
                      {
                        '#': {
                          '@$': 'researchType',
                        },
                      },
                      0,
                    ],
                  },
                  {
                    in: [
                      {
                        '@': 'researchType',
                      },
                      {
                        '@$': 'researchType',
                      },
                    ],
                  },
                ],
              },
              {
                if: [
                  [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      '=': [
                        {
                          '@$': 'shouldAnalyze',
                        },
                        {
                          '@': 'shouldAnalyze',
                        },
                      ],
                    },
                  ],
                  true,
                ],
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '{}': {
              mtdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
            },
          },
          subqueries: {
            researchType: {
              ref: {
                attr: 'attr:ent#!projects#!proj:!award',
              },
              target: 'ent:!awards:!award',
              selection: {
                '@.': '!research_type_wfuhs',
              },
            },
            shouldAnalyze: {
              ref: {
                attr: 'attr:ent#!projects#!proj:!org',
              },
              target: 'ent:!org:!dept',
              selection: {
                '@.': '!should_analyze',
              },
            },
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '@': 'isInMtdc',
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                isInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!is_in_mtdc',
                  },
                },
              },
            },
          },
        },
        piSpaceAssignments: {
          ref: {
            attr: 'attr:ent#!person_space#!entry:!personnel',
          },
          target: 'ent:!person_space:!entry',
        },
        piProjectAssignments: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!pi',
          },
          target: 'ent:!proj_pis:!entry',
        },
      },
    },
    '2023_pi': {
      filter: {
        and: [
          {
            '@$': 'piRecordId',
          },
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2023',
          },
          start: {
            $date: '1/1/2023',
          },
        },
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '{}': {
          totalAsf: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'asf',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          mtdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          mtdcDensity: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'mtdcAmount',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
        },
      },
      subqueries: {
        rooms: {
          ref: {
            attr: 'attr:ent#!person_space#!entry:!space',
          },
          using: 'piSpaceAssignments',
          filter: {
            and: [
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'spaceType',
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': [
                          '!space_use',
                          {
                            ref: {
                              entity: '!group',
                            },
                          },
                        ],
                      },
                      {
                        '@>': [
                          {
                            '@$': 'spaceType',
                          },
                          'ent:!space_use:!group',
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                if: [
                  [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      '=': [
                        {
                          '@$': 'shouldAnalyze',
                        },
                        {
                          in: [
                            true,
                            {
                              '@': 'shouldAnalyze',
                            },
                          ],
                        },
                      ],
                    },
                  ],
                  true,
                ],
              },
            ],
          },
          target: 'ent:!space:!room',
          selection: {
            '{}': {
              asf: {
                '*': [
                  {
                    '@.': '!sqft',
                  },
                  {
                    '/': [
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '*': [
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'allowable',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              sqft: {
                '@.': '!sqft',
              },
            },
          },
          subqueries: {
            weights: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!space',
                inherit: '-',
              },
              filter: {
                '!=': [
                  {
                    '@.': '!weight',
                  },
                  0,
                ],
              },
              target: 'ent:!space_funcl:!entry',
              selection: {
                '{}': {
                  value: {
                    '@.': '!weight',
                  },
                  allowable: {
                    if: [
                      [
                        {
                          '!=': [
                            {
                              '@': 'funcIdCat',
                            },
                            null,
                          ],
                        },
                        1,
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                funcIdCat: {
                  ref: {
                    attr: 'attr:ent#!space_funcl#!entry:!func_space',
                  },
                  target: 'ent:!func_space:!func',
                  selection: {
                    '@.': [
                      '!func_idc',
                      {
                        ref: {
                          entity: '!cat',
                        },
                      },
                    ],
                  },
                },
              },
            },
            roomOrgs: {
              ref: {
                attr: 'attr:ent#!org_space#!entry:!space',
              },
              target: 'ent:!org_space:!entry',
            },
            shouldAnalyze: {
              ref: {
                attr: 'attr:ent#!org_space#!entry:!org',
              },
              using: 'roomOrgs',
              target: 'ent:!org:!dept',
              selection: {
                '@.': '!should_analyze',
              },
            },
          },
        },
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          using: 'piProjectAssignments',
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'researchType',
                      },
                      null,
                    ],
                  },
                  {
                    '=': [
                      {
                        '#': {
                          '@$': 'researchType',
                        },
                      },
                      0,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': '!research_type_wfuhs',
                      },
                      {
                        '@$': 'researchType',
                      },
                    ],
                  },
                ],
              },
              {
                if: [
                  [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      '=': [
                        {
                          '@$': 'shouldAnalyze',
                        },
                        {
                          '@': 'shouldAnalyze',
                        },
                      ],
                    },
                  ],
                  true,
                ],
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '{}': {
              mtdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
            },
          },
          subqueries: {
            shouldAnalyze: {
              ref: {
                attr: 'attr:ent#!projects#!proj:!org',
              },
              target: 'ent:!org:!dept',
              selection: {
                '@.': '!should_analyze',
              },
            },
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '@': 'isInMtdc',
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                isInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!is_in_mtdc',
                  },
                },
              },
            },
          },
        },
        piSpaceAssignments: {
          ref: {
            attr: 'attr:ent#!person_space#!entry:!personnel',
          },
          target: 'ent:!person_space:!entry',
        },
        piProjectAssignments: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!pi',
          },
          target: 'ent:!proj_pis:!entry',
        },
      },
    },
    '2024_pi': {
      filter: {
        and: [
          {
            '@$': 'piRecordId',
          },
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              {
                '@.': '!id',
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2024',
          },
          start: {
            $date: '1/1/2024',
          },
        },
      },
      target: 'ent:!personnel:!employee',
      selection: {
        '{}': {
          totalAsf: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'asf',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          mtdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          mtdcDensity: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'mtdcAmount',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
        },
      },
      subqueries: {
        rooms: {
          ref: {
            attr: 'attr:ent#!person_space#!entry:!space',
          },
          using: 'piSpaceAssignments',
          filter: {
            and: [
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'spaceType',
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': [
                          '!space_use',
                          {
                            ref: {
                              entity: '!group',
                            },
                          },
                        ],
                      },
                      {
                        '@>': [
                          {
                            '@$': 'spaceType',
                          },
                          'ent:!space_use:!group',
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                if: [
                  [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      '=': [
                        {
                          '@$': 'shouldAnalyze',
                        },
                        {
                          in: [
                            true,
                            {
                              '@': 'shouldAnalyze',
                            },
                          ],
                        },
                      ],
                    },
                  ],
                  true,
                ],
              },
            ],
          },
          target: 'ent:!space:!room',
          selection: {
            '{}': {
              asf: {
                '*': [
                  {
                    '@.': '!sqft',
                  },
                  {
                    '/': [
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '*': [
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'allowable',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              sqft: {
                '@.': '!sqft',
              },
            },
          },
          subqueries: {
            weights: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!space',
                inherit: '-',
              },
              filter: {
                '!=': [
                  {
                    '@.': '!weight',
                  },
                  0,
                ],
              },
              target: 'ent:!space_funcl:!entry',
              selection: {
                '{}': {
                  value: {
                    '@.': '!weight',
                  },
                  allowable: {
                    if: [
                      [
                        {
                          '!=': [
                            {
                              '@': 'funcIdCat',
                            },
                            null,
                          ],
                        },
                        1,
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                funcIdCat: {
                  ref: {
                    attr: 'attr:ent#!space_funcl#!entry:!func_space',
                  },
                  target: 'ent:!func_space:!func',
                  selection: {
                    '@.': [
                      '!func_idc',
                      {
                        ref: {
                          entity: '!cat',
                        },
                      },
                    ],
                  },
                },
              },
            },
            roomOrgs: {
              ref: {
                attr: 'attr:ent#!org_space#!entry:!space',
              },
              target: 'ent:!org_space:!entry',
            },
            shouldAnalyze: {
              ref: {
                attr: 'attr:ent#!org_space#!entry:!org',
              },
              using: 'roomOrgs',
              target: 'ent:!org:!dept',
              selection: {
                '@.': '!should_analyze',
              },
            },
          },
        },
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!proj',
          },
          using: 'piProjectAssignments',
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'researchType',
                      },
                      null,
                    ],
                  },
                  {
                    '=': [
                      {
                        '#': {
                          '@$': 'researchType',
                        },
                      },
                      0,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': '!research_type_wfuhs',
                      },
                      {
                        '@$': 'researchType',
                      },
                    ],
                  },
                ],
              },
              {
                if: [
                  [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      '=': [
                        {
                          '@$': 'shouldAnalyze',
                        },
                        {
                          '@': 'shouldAnalyze',
                        },
                      ],
                    },
                  ],
                  true,
                ],
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '{}': {
              mtdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
            },
          },
          subqueries: {
            shouldAnalyze: {
              ref: {
                attr: 'attr:ent#!projects#!proj:!org',
              },
              target: 'ent:!org:!dept',
              selection: {
                '@.': '!should_analyze',
              },
            },
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '@': 'isInMtdc',
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                isInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!is_in_mtdc',
                  },
                },
              },
            },
          },
        },
        piSpaceAssignments: {
          ref: {
            attr: 'attr:ent#!person_space#!entry:!personnel',
          },
          target: 'ent:!person_space:!entry',
        },
        piProjectAssignments: {
          ref: {
            attr: 'attr:ent#!proj_pis#!entry:!pi',
          },
          target: 'ent:!proj_pis:!entry',
        },
      },
    },
    '2022_org': {
      filter: {
        and: [
          {
            '@$': 'orgEntityId',
          },
          {
            '@$': 'orgRecordId',
          },
          {
            '=': [
              {
                '@.': '!id',
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            '=': [
              {
                '@_': 'id',
              },
              {
                '@$': 'orgEntityId',
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2022',
          },
          start: {
            $date: '1/1/2022',
          },
        },
      },
      target: 'dim::!org',
      selection: {
        '{}': {
          totalAsf: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'asf',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          mtdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          mtdcDensity: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'mtdcAmount',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
        },
      },
      subqueries: {
        rooms: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          using: 'orgSpaceAssignments',
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': [
                      '!space_use',
                      {
                        ref: {
                          entity: '!group',
                        },
                      },
                    ],
                  },
                  {
                    '@>': [
                      {
                        '@$': 'spaceType',
                      },
                      'ent:!space_use:!group',
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!space:!room',
          selection: {
            '{}': {
              asf: {
                '*': [
                  {
                    '@.': '!sqft',
                  },
                  {
                    '/': [
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '*': [
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'allowable',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              sqft: {
                '@.': '!sqft',
              },
            },
          },
          subqueries: {
            weights: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!space',
                inherit: '-',
              },
              filter: {
                '!=': [
                  {
                    '@.': '!weight',
                  },
                  0,
                ],
              },
              target: 'ent:!space_funcl:!entry',
              selection: {
                '{}': {
                  value: {
                    '@.': '!weight',
                  },
                  allowable: {
                    if: [
                      [
                        {
                          '!=': [
                            {
                              '@': 'funcIdCat',
                            },
                            null,
                          ],
                        },
                        1,
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                funcIdCat: {
                  ref: {
                    attr: 'attr:ent#!space_funcl#!entry:!func_space',
                  },
                  target: 'ent:!func_space:!func',
                  selection: {
                    '@.': [
                      '!func_idc',
                      {
                        ref: {
                          entity: '!cat',
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
            inherit: '-',
          },
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'researchType',
                      },
                      null,
                    ],
                  },
                  {
                    '=': [
                      {
                        '#': {
                          '@$': 'researchType',
                        },
                      },
                      0,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': '!research_type_wfuhs',
                      },
                      {
                        '@$': 'researchType',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '{}': {
              mtdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '@': 'isInMtdc',
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                isInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!is_in_mtdc',
                  },
                },
              },
            },
          },
        },
        orgSpaceAssignments: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!org',
            inherit: '-',
          },
          target: 'ent:!org_space:!entry',
        },
      },
    },
    '2023_org': {
      filter: {
        and: [
          {
            '@$': 'orgEntityId',
          },
          {
            '@$': 'orgRecordId',
          },
          {
            '=': [
              {
                '@.': '!id',
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            '=': [
              {
                '@_': 'id',
              },
              {
                '@$': 'orgEntityId',
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2023',
          },
          start: {
            $date: '1/1/2023',
          },
        },
      },
      target: 'dim::!org',
      selection: {
        '{}': {
          totalAsf: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'asf',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          mtdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          mtdcDensity: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'mtdcAmount',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
        },
      },
      subqueries: {
        rooms: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          using: 'orgSpaceAssignments',
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': [
                      '!space_use',
                      {
                        ref: {
                          entity: '!group',
                        },
                      },
                    ],
                  },
                  {
                    '@>': [
                      {
                        '@$': 'spaceType',
                      },
                      'ent:!space_use:!group',
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!space:!room',
          selection: {
            '{}': {
              asf: {
                '*': [
                  {
                    '@.': '!sqft',
                  },
                  {
                    '/': [
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '*': [
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'allowable',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              sqft: {
                '@.': '!sqft',
              },
            },
          },
          subqueries: {
            weights: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!space',
                inherit: '-',
              },
              filter: {
                '!=': [
                  {
                    '@.': '!weight',
                  },
                  0,
                ],
              },
              target: 'ent:!space_funcl:!entry',
              selection: {
                '{}': {
                  value: {
                    '@.': '!weight',
                  },
                  allowable: {
                    if: [
                      [
                        {
                          '!=': [
                            {
                              '@': 'funcIdCat',
                            },
                            null,
                          ],
                        },
                        1,
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                funcIdCat: {
                  ref: {
                    attr: 'attr:ent#!space_funcl#!entry:!func_space',
                  },
                  target: 'ent:!func_space:!func',
                  selection: {
                    '@.': [
                      '!func_idc',
                      {
                        ref: {
                          entity: '!cat',
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
            inherit: '-',
          },
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'researchType',
                      },
                      null,
                    ],
                  },
                  {
                    '=': [
                      {
                        '#': {
                          '@$': 'researchType',
                        },
                      },
                      0,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': '!research_type_wfuhs',
                      },
                      {
                        '@$': 'researchType',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '{}': {
              mtdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '@': 'isInMtdc',
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                isInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!is_in_mtdc',
                  },
                },
              },
            },
          },
        },
        orgSpaceAssignments: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!org',
            inherit: '-',
          },
          target: 'ent:!org_space:!entry',
        },
      },
    },
    '2024_org': {
      filter: {
        and: [
          {
            '@$': 'orgEntityId',
          },
          {
            '@$': 'orgRecordId',
          },
          {
            '=': [
              {
                '@.': '!id',
              },
              {
                '@$': 'orgRecordId',
              },
            ],
          },
          {
            '=': [
              {
                '@_': 'id',
              },
              {
                '@$': 'orgEntityId',
              },
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2024',
          },
          start: {
            $date: '1/1/2024',
          },
        },
      },
      target: 'dim::!org',
      selection: {
        '{}': {
          totalAsf: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'rooms',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'asf',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          mtdcAmount: {
            '??': [
              {
                '+': {
                  '->': [
                    {
                      '@': 'projectsExpenses',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
              0,
            ],
          },
          mtdcDensity: {
            if: [
              [
                {
                  '=': [
                    {
                      '@>': 'totalAsf',
                    },
                    0,
                  ],
                },
                0,
              ],
              {
                '/': [
                  {
                    '@>': 'mtdcAmount',
                  },
                  {
                    '@>': 'totalAsf',
                  },
                ],
              },
            ],
          },
        },
      },
      subqueries: {
        rooms: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          using: 'orgSpaceAssignments',
          filter: {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceType',
                  },
                  null,
                ],
              },
              {
                in: [
                  {
                    '@.': [
                      '!space_use',
                      {
                        ref: {
                          entity: '!group',
                        },
                      },
                    ],
                  },
                  {
                    '@>': [
                      {
                        '@$': 'spaceType',
                      },
                      'ent:!space_use:!group',
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!space:!room',
          selection: {
            '{}': {
              asf: {
                '*': [
                  {
                    '@.': '!sqft',
                  },
                  {
                    '/': [
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '*': [
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'allowable',
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        '+': {
                          '->': [
                            {
                              '@': 'weights',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'value',
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              sqft: {
                '@.': '!sqft',
              },
            },
          },
          subqueries: {
            weights: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!space',
                inherit: '-',
              },
              filter: {
                '!=': [
                  {
                    '@.': '!weight',
                  },
                  0,
                ],
              },
              target: 'ent:!space_funcl:!entry',
              selection: {
                '{}': {
                  value: {
                    '@.': '!weight',
                  },
                  allowable: {
                    if: [
                      [
                        {
                          '!=': [
                            {
                              '@': 'funcIdCat',
                            },
                            null,
                          ],
                        },
                        1,
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                funcIdCat: {
                  ref: {
                    attr: 'attr:ent#!space_funcl#!entry:!func_space',
                  },
                  target: 'ent:!func_space:!func',
                  selection: {
                    '@.': [
                      '!func_idc',
                      {
                        ref: {
                          entity: '!cat',
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
        projectsExpenses: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
            inherit: '-',
          },
          filter: {
            and: [
              {
                not: {
                  '=': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    null,
                  ],
                },
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'researchType',
                      },
                      null,
                    ],
                  },
                  {
                    '=': [
                      {
                        '#': {
                          '@$': 'researchType',
                        },
                      },
                      0,
                    ],
                  },
                  {
                    in: [
                      {
                        '@.': '!research_type_wfuhs',
                      },
                      {
                        '@$': 'researchType',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!projects:!proj',
          selection: {
            '{}': {
              mtdcAmount: {
                '+': {
                  '->': [
                    {
                      '@': 'projectGlExpenseAmounts',
                    },
                    {
                      '@>': [
                        {
                          '@$': '$value',
                        },
                        'mtdcAmount',
                      ],
                    },
                  ],
                },
              },
            },
          },
          subqueries: {
            projectGlExpenseAmounts: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!gl_exp:!entry',
              selection: {
                '{}': {
                  mtdcAmount: {
                    if: [
                      [
                        {
                          '@': 'isInMtdc',
                        },
                        {
                          '@.': '!amount',
                        },
                      ],
                      0,
                    ],
                  },
                },
              },
              subqueries: {
                isInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!acct',
                  },
                  target: 'ent:!gl_accts:!acct',
                  selection: {
                    '@.': '!is_in_mtdc',
                  },
                },
              },
            },
          },
        },
        orgSpaceAssignments: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!org',
            inherit: '-',
          },
          target: 'ent:!org_space:!entry',
        },
      },
    },
    projectsGlExpenses: {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'spaceEntityId',
                  },
                  null,
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'researchType',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '#': {
                      '@$': 'researchType',
                    },
                  },
                  0,
                ],
              },
              {
                in: [
                  {
                    '@.': '!research_type_wfuhs',
                  },
                  {
                    '@$': 'researchType',
                  },
                ],
              },
            ],
          },
          {
            if: [
              [
                {
                  '@$': 'shouldAnalyze',
                },
                {
                  '=': [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      in: [
                        true,
                        {
                          '@': 'shouldAnalyze',
                        },
                      ],
                    },
                  ],
                },
              ],
              true,
            ],
          },
        ],
      },
      target: 'ent:!projects:!proj',
      selection: {
        '{}': {
          tdcAmount: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'tdcAmount',
                  ],
                },
              ],
            },
          },
          mtdcAmount: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'mtdcAmount',
                  ],
                },
              ],
            },
          },
        },
      },
      subqueries: {
        glExpenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '{}': {
              tdcAmount: {
                '@.': '!amount',
              },
              mtdcAmount: {
                if: [
                  [
                    {
                      '@': 'isInMtdc',
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
          },
        },
        shouldAnalyze: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
          },
          target: 'dim::!org',
          selection: {
            '@.': '!should_analyze',
          },
        },
      },
    },
    '2022_projectsGlExpenses': {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'spaceEntityId',
                  },
                  null,
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'researchType',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '#': {
                      '@$': 'researchType',
                    },
                  },
                  0,
                ],
              },
              {
                in: [
                  {
                    '@.': '!research_type_wfuhs',
                  },
                  {
                    '@$': 'researchType',
                  },
                ],
              },
            ],
          },
          {
            if: [
              [
                {
                  '@$': 'shouldAnalyze',
                },
                {
                  '=': [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      in: [
                        true,
                        {
                          '@': 'shouldAnalyze',
                        },
                      ],
                    },
                  ],
                },
              ],
              true,
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2022',
          },
          start: {
            $date: '1/1/2022',
          },
        },
      },
      target: 'ent:!projects:!proj',
      selection: {
        '{}': {
          mtdcAmount: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'mtdcAmount',
                  ],
                },
              ],
            },
          },
        },
      },
      subqueries: {
        glExpenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '{}': {
              mtdcAmount: {
                if: [
                  [
                    {
                      '@': 'isInMtdc',
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
          },
        },
        shouldAnalyze: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
          },
          target: 'dim::!org',
          selection: {
            '@.': '!should_analyze',
          },
        },
      },
    },
    '2023_projectsGlExpenses': {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'spaceEntityId',
                  },
                  null,
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'researchType',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '#': {
                      '@$': 'researchType',
                    },
                  },
                  0,
                ],
              },
              {
                in: [
                  {
                    '@.': '!research_type_wfuhs',
                  },
                  {
                    '@$': 'researchType',
                  },
                ],
              },
            ],
          },
          {
            if: [
              [
                {
                  '@$': 'shouldAnalyze',
                },
                {
                  '=': [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      in: [
                        true,
                        {
                          '@': 'shouldAnalyze',
                        },
                      ],
                    },
                  ],
                },
              ],
              true,
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2023',
          },
          start: {
            $date: '1/1/2023',
          },
        },
      },
      target: 'ent:!projects:!proj',
      selection: {
        '{}': {
          mtdcAmount: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'mtdcAmount',
                  ],
                },
              ],
            },
          },
        },
      },
      subqueries: {
        glExpenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '{}': {
              mtdcAmount: {
                if: [
                  [
                    {
                      '@': 'isInMtdc',
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
          },
        },
        shouldAnalyze: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
          },
          target: 'dim::!org',
          selection: {
            '@.': '!should_analyze',
          },
        },
      },
    },
    '2024_projectsGlExpenses': {
      filter: {
        and: [
          {
            '=': [
              {
                '@$': 'piRecordId',
              },
              null,
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'orgRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'orgEntityId',
                  },
                  null,
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'spaceRecordId',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '@$': 'spaceEntityId',
                  },
                  null,
                ],
              },
            ],
          },
          {
            or: [
              {
                '=': [
                  {
                    '@$': 'researchType',
                  },
                  null,
                ],
              },
              {
                '=': [
                  {
                    '#': {
                      '@$': 'researchType',
                    },
                  },
                  0,
                ],
              },
              {
                in: [
                  {
                    '@.': '!research_type_wfuhs',
                  },
                  {
                    '@$': 'researchType',
                  },
                ],
              },
            ],
          },
          {
            if: [
              [
                {
                  '@$': 'shouldAnalyze',
                },
                {
                  '=': [
                    {
                      '@$': 'shouldAnalyze',
                    },
                    {
                      in: [
                        true,
                        {
                          '@': 'shouldAnalyze',
                        },
                      ],
                    },
                  ],
                },
              ],
              true,
            ],
          },
        ],
      },
      period: {
        $range: {
          end: {
            $date: '12/31/2024',
          },
          start: {
            $date: '1/1/2024',
          },
        },
      },
      target: 'ent:!projects:!proj',
      selection: {
        '{}': {
          mtdcAmount: {
            '+': {
              '->': [
                {
                  '@': 'glExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'mtdcAmount',
                  ],
                },
              ],
            },
          },
        },
      },
      subqueries: {
        glExpenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '{}': {
              mtdcAmount: {
                if: [
                  [
                    {
                      '@': 'isInMtdc',
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
          },
        },
        shouldAnalyze: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
          },
          target: 'dim::!org',
          selection: {
            '@.': '!should_analyze',
          },
        },
      },
    },
  },
}
